$(document).ready(function () {
    let results = {};
    let value, key;
    let objectStructure = null;
    let index = 0;
    let currentSection = 1;
    let totalQuestionSections = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sections_amount')) || 6;
    let totalSections = totalQuestionSections + (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sections_amount_intro')) || 0);

    const localStorageKey = 'triggerQuestion';

    // Clean up utm_content on page load - remove any fwSurvey-[something] values
    function cleanupUtmContent() {
        const urlString = window.location.href;
        const urlParams = new URLSearchParams(new URL(urlString).search);
        const currentUtmContent = urlParams.get('utm_content');
        
        if (currentUtmContent) {
            // Remove fwSurvey-[something] pattern from utm_content
            const fwSurveyRegex = /_?fwSurvey-[^_]+/g;
            const cleanedUtmContent = currentUtmContent.replace(fwSurveyRegex, '').replace(/^_+|_+$/g, '');
            
            if (cleanedUtmContent !== currentUtmContent) {
                if (cleanedUtmContent) {
                    urlParams.set('utm_content', cleanedUtmContent);
                } else {
                    urlParams.delete('utm_content');
                }
                
                // Update URL without reloading page
                const baseUrl = urlString.split('?')[0];
                const newUrl = urlParams.toString() ? `${baseUrl}?${urlParams.toString()}` : baseUrl;
                window.history.replaceState({}, '', newUrl);
                
                // Update all elements with data-param attribute
                const newUrlParams = newUrl.includes('?') ? newUrl.split('?')[1] : '';
                document.querySelectorAll('[data-param]').forEach(element => {
                    element.setAttribute('data-param', newUrlParams);
                    if (element.href) {
                        const baseHref = element.href.split('?')[0];
                        element.setAttribute('href', baseHref + (newUrlParams ? '?' + newUrlParams : ''));
                    }
                });
                
                // console.log('Cleaned utm_content on page load:', cleanedUtmContent || 'utm_content removed');
            }
        }
    }

    // Run cleanup on page load
    cleanupUtmContent();

    // Clear localStorage values on page load
    function clearLocalStorageValues() {
        // Only clear localStorage on the survey page, not on destination pages
        const isSurveyPage = document.querySelector('.surveyPage') !== null;
        if (!isSurveyPage) {
            // console.log('Not on survey page, skipping localStorage clear');
            return;
        }

        // Hardcoded localStorage key approach
        localStorage.setItem(localStorageKey, '');
        // console.log(`Cleared localStorage for hardcoded key: ${localStorageKey}`);
    }

    // Clear localStorage on page load
    clearLocalStorageValues();

    // Completely dynamic section names generation - no hardcoded arrays
    function generateSectionNames(count) {
        const sectionNames = [];
        
        for (let i = 1; i <= count; i++) {
            // Generate names dynamically without hardcoded arrays
            const name = generateSectionName(i);
            sectionNames.push(name);
        }
        
        return sectionNames;
    }
    
    // Generate section names programmatically
    function generateSectionName(num) {
        // For simplicity and consistency, use sectionX format for all sections
        // This eliminates any hardcoded arrays and makes it truly dynamic
        return `section${num}`;
    }
    
    const sectionNames = generateSectionNames(totalQuestionSections);

    // Record Selected Answer
    function createObj(obj) {
        key = obj.closest('.box').find('h2').data('title');
        value = obj.closest('li').find('input').val();
        const currentLi = obj.closest('li');
        const isSelected = currentLi.hasClass('selected');
        
        if (objectStructure == null) {
            results[key] = value;
        } else if (obj.closest('.box').hasClass('box--multiple-answer')) {
            // Handle multiple answer questions
            if (isSelected) {
                // Answer is being selected - add it to the array
                if (typeof results[key] === 'object') {
                    // Check if value already exists to avoid duplicates
                    const valueExists = Object.values(results[key]).includes(value);
                    if (!valueExists) {
                        results[key][index++] = value;
                    }
                } else {
                    results[key] = {};
                    results[key][0] = value;
                }
            } else {
                // Answer is being deselected - remove it from the array
                if (typeof results[key] === 'object') {
                    // Find and remove the deselected value
                    for (let i in results[key]) {
                        if (results[key][i] === value) {
                            delete results[key][i];
                            break;
                        }
                    }
                }
            }
        } else {
            // Single answer questions - always set the value
            results[key] = value;
        }

        objectStructure = results;
        console.log(objectStructure);
    }

    // Rebuild multiple answer object for a specific question
    function rebuildMultipleAnswerObject(boxElement) {
        const questionTitle = boxElement.find('h2').data('title');
        const selectedAnswers = boxElement.find('li.selected');
        
        if (selectedAnswers.length > 0) {
            // Create new array for this question
            results[questionTitle] = {};
            selectedAnswers.each(function(index) {
                const value = $(this).find('input').val();
                results[questionTitle][index] = value;
            });
        } else {
            // No answers selected, remove the question from results
            delete results[questionTitle];
        }
        
        objectStructure = results;
        console.log(objectStructure);
    }

    // Disable other answer options in single-answer questions
    function disableOtherAnswers(boxElement, selectedLi) {
        // Find all other answer options in this question
        const otherAnswers = boxElement.find('li').not(selectedLi);
        
        // Disable the input and add disabled class to li
        otherAnswers.find('input').prop('disabled', true);
        otherAnswers.addClass('disabled');
    }

    function updateSurveyClass(sectionNumber) {
        const surveySection = $('#surveySection');
        const currentSectionName = sectionNames[sectionNumber - 1];
        
        // Remove all existing section classes dynamically
        sectionNames.forEach(name => {
            surveySection.removeClass(name);
        });
        
        // Add the current section class
        surveySection.addClass(currentSectionName);
        
        // Update data attribute
        surveySection.attr('data-current-section', sectionNumber);
        
        // Update pagination active state
        $(`.pagination__item[data-section="${sectionNumber}"]`).addClass('active');
        
        // Update current section variable
        currentSection = sectionNumber;
        
        // Update progress bar to match current section
        updateProgressBar(sectionNumber);
    }

    // Function to update GTM skip classes on the skip button
    function updateSkipButtonGTMClass(sectionNumber) {
        const nextStepButton = $('#nextStep');
        const skipButton = $('#skipQuestion');
        if (skipButton.length === 0 || nextStepButton.length === 0) return;
        
        // Remove any existing gtm-skip-* classes
        skipButton.removeClass(function(index, className) {
            return (className.match(/(^|\s)gtm-skip-\S+/g) || []).join(' ');
        });

        nextStepButton.removeClass(function(index, className) {
            return (className.match(/(^|\s)gtm-next-step-\S+/g) || []).join(' ');
        });
        
        // Get the GTM value from the current section
        const currentSection = $('.box').eq(sectionNumber - 1);
        const gtmValue = currentSection.data('gtm-section');
        
        if (gtmValue) {
            // Add the new gtm-skip-{gtmValue} class
            skipButton.addClass(`gtm-skip-${gtmValue}`);
            nextStepButton.addClass(`gtm-next-step-${gtmValue}`);
            // console.log(`Updated skip button GTM class to: gtm-skip-${gtmValue}`);
        } 
    }

    function goToNextSection() {
        if (currentSection < totalQuestionSections) {
            const nextSection = currentSection + 1;
            updateSurveyClass(nextSection);
            
            // Update the skip button GTM class when moving to next section
            updateSkipButtonGTMClass(nextSection);
            
            return true;
        }
        return false;
    }

    function goToPreviousSection() {
        if (currentSection > 1) {
            updateSurveyClass(currentSection - 1);
            return true;
        }
        return false;
    }

    function pagination() {
        const box = $('.box');
        let isSingleAnswer = false;

        $('label').on('click', function () {
            const currentLi = $(this).closest('li');
            
            // Prevent double-clicks on single-answer questions
            if (isSingleAnswer) {
                return;
            }
            
            // Check if this is a multiple answer box
            if (!$(this).closest(box).hasClass('box--multiple-answer')) { // Not a multiple answer box
                // Set processing flag to prevent double-clicks
                isSingleAnswer = true;
                
                // Add selected class to the closest li element
                $(this).closest('li').addClass('selected');

                // Disable other answer options in this question excluding in last question
                if(!box.last()) {
                    disableOtherAnswers($(this).closest(box), $(this).closest('li'));
                }

                if(box.last()) {
                    const currentBox = $(this).closest(box);
                    currentBox.find('li.selected').removeClass('selected');
                    currentLi.addClass('selected');
                }

                // Create object for the selected answer (after adding selected class)
                createObj($(this));

                // Single answer - update progress bar and move to next section
                updateProgressBar(currentSection + 1);
                
                if (goToNextSection()) {                    
                    // Scroll to top if not the last section
                    if (currentSection < totalQuestionSections) {
                        scrollToTop();
                    }
                }
                
                // Reset processing flag after navigation (with a small delay to ensure smooth transition)
                setTimeout(() => {
                    isSingleAnswer = false;
                }, 500);
            } else { // Multiple answer box
                // Check if this is a unique value item
                const clickedLabel = $(this); // The label that was clicked
                const isUniqueValue = clickedLabel.data('unique') === 'true' || 
                                    clickedLabel.attr('data-unique') === 'true';
                
                if (isUniqueValue) { // Multiple answer box with unique value item
                    // console.log('Unique value item selected - treating as single answer');
                    
                    // For unique value items: unselect all others and select only this one
                    const currentBox = $(this).closest(box);
                    currentBox.find('li.selected').removeClass('selected');
                    currentLi.addClass('selected');
                    
                    // Clear all answers for this question and add only the unique value
                    const questionTitle = currentBox.find('h2').data('title');
                    const uniqueValue = currentLi.find('input').val();
                    
                    // Remove the question from results and add it back with only the unique value
                    delete results[questionTitle];
                    results[questionTitle] = uniqueValue;
                    
                    objectStructure = results;
                    console.log(objectStructure);

                    if (goToNextSection()) {
                        // Scroll to top if not the last section
                        scrollToTop();
                    }
                    
                    // Hide Next Step CTA since unique value behaves like single answer
                    $('#nextStep').addClass('hidden');
                    
                    // Process as single answer (update progress and move to next section)
                    updateProgressBar(currentSection + 1);
                
                } else { // Regular multiple answer behavior
                    // Regular multiple answer behavior
                    currentLi.toggleClass('selected');
                    
                    // For multiple answer boxes, rebuild the entire object for this question
                    rebuildMultipleAnswerObject($(this).closest(box));
                    
                    // Check if any answers are selected
                    const currentBox = $(this).closest(box);
                    const selectedAnswers = currentBox.find('li.selected').length;
                    
                    if (selectedAnswers > 0) {
                        // Show Next Step CTA when at least one answer is selected
                        $('#nextStep').removeClass('hidden');
                    } else {
                        // Hide Next Step CTA when no answers are selected
                        $('#nextStep').addClass('hidden');
                    }
                }
            }

            // Get #header and #footer height when clicking answers
            getHeights();

            // Handle trigger question
            if(!$(this).data('trigger')) {
                return;
            } else {
                // Get form data from clicked label
                const $label = $(this);
                const isTriggerQuestion = $label.data('trigger');
                // Commented out variables no longer needed with hardcoded localStorageKey
                // const labelFor = $label.attr('for');
                // const $inputElement = $('#' + labelFor);
                
                // Store in localStorage with hardcoded key
                localStorage.setItem(localStorageKey, isTriggerQuestion);
                
                // Commented out dynamic approach - replaced with hardcoded localStorageKey
                // localStorage.setItem($inputElement.attr('name'), isTriggerQuestion);

                // Get URL parameters
                const urlString = window.location.href;
                const urlParams = new URLSearchParams(new URL(urlString).search);
                
                // Get input data
                const labelFor = $label.attr('for');
                const $inputElement = $('#' + labelFor);
                const paramsToForward = $inputElement.data('param-fw');
                const thisParamValue = $inputElement.attr('id');

                // console.log('Form data:', {
                //     label: $label,
                //     paramsToForward,
                //     thisParamValue,
                //     localStorageKey: localStorageKey,
                //     isTriggerQuestion: isTriggerQuestion
                // });

                // Update utm_content if params should be forwarded
                if (paramsToForward) {
                    const currentUtmContent = urlParams.get('utm_content');
                    let newUtmContent;
                    
                    if (currentUtmContent) {
                        // Check if utm_content already contains fwSurvey-[something]
                        const fwSurveyRegex = /_fwSurvey-[^_]+/g;
                        const hasFwSurvey = fwSurveyRegex.test(currentUtmContent);
                        
                        if (hasFwSurvey) {
                            // Replace existing fwSurvey value
                            newUtmContent = currentUtmContent.replace(fwSurveyRegex, `_fwSurvey-${thisParamValue}`);
                        } else {
                            // Append new fwSurvey value
                            newUtmContent = `${currentUtmContent}_fwSurvey-${thisParamValue}`;
                        }
                    } else {
                        // No existing utm_content, create new one
                        newUtmContent = `fwSurvey-${thisParamValue}`;
                    }
                    
                    urlParams.set('utm_content', newUtmContent);
                    // console.log('Updated utm_content:', newUtmContent);
                }

                // Update URL without reloading page
                const newUrl = !urlString.includes("fwSurvey-Skip") 
                    ? `${urlString.split('?')[0]}?${urlParams.toString()}`
                    : urlString;
                
                // console.log('New URL:', newUrl);
                window.history.pushState({}, '', newUrl);

                // Update all elements with data-param attribute
                const newUrlParams = newUrl.includes('?') ? newUrl.split('?')[1] : '';
                document.querySelectorAll('[data-param]').forEach(element => {
                    element.setAttribute('data-param', newUrlParams);
                    // If element has href, update it too
                    if (element.href) {
                        const baseHref = element.href.split('?')[0];
                        element.setAttribute('href', baseHref + (newUrlParams ? '?' + newUrlParams : ''));
                    }
                });
            }
        });

        // Handle last section completion
        box.last().find('label').on('click', function () {
            // Update progress bar to 100% when completing the last question
            updateProgressBar(totalQuestionSections);
            
            $('#nextPage').removeClass('hidden');
            box.last().addClass('clicked');
            $('.skip').addClass('clicked');

            // Get #header and #footer height
            getHeights();
        });
    }

    // Add click handlers to pagination items for direct navigation
    function initPaginationNavigation() {
        $('.pagination__item').on('click', function() {
            const sectionNumber = parseInt($(this).data('section'));

            if (sectionNumber && sectionNumber !== currentSection) {
                updateSurveyClass(sectionNumber);
                
                // Scroll to top when navigating
                scrollToTop();
            }
        });
    }

    const updateProgressBar = (sectionNumber) => {
        const progressBar = document.getElementById('formProgressBar');
        if (progressBar) {
            // Calculate progress based on current question position
            // Each question represents an equal portion of the total
            // For 6 questions: each = 16.66667% (100% ÷ 6)
            const progressPercentage = (sectionNumber / totalQuestionSections) * 100;
            progressBar.style.setProperty('--progressBarWidth', progressPercentage + '%');
        }
    }

    // Scroll to top of the page
    function scrollToTop() {
        $('html, body').animate({
            scrollTop: $(".header").offset().top
        }, 1000);
    }

    // Get #header and #footer height
    function getHeights() {
        let headerHeight = $('#header').outerHeight();
        let footerHeight = $('#footer').outerHeight();

        // Add header height to control main height of 100dvh - var(--header-height)
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');

        // Add footer height as .boxes margin-bottom via CSS variable and adjust it 
        document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
    }

    // Add event listener for startQuiz button
    $('#startQuiz').on('click', function() {
        $('#surveyIntro').addClass('animateFadeOut');
        $('#surveySection').addClass('animateFadeIn');

        // Scroll to top when navigating
        scrollToTop();
    });

    // Add event listener for skipIntro button
    $('#skipIntro').on('click', function() {
        addFwSurveyToUtmContent('skipIntro');
        clearLocalStorageValues();
    });

    // Add event listener for skipQuestion button
    $('#skipQuestion').on('click', function() {
        addFwSurveyToUtmContent('skip');
        clearLocalStorageValues();
    });

    // Function to add fwSurvey value to utm_content
    function addFwSurveyToUtmContent(skipType) {
        const urlString = window.location.href;
        const urlParams = new URLSearchParams(new URL(urlString).search);
        const currentUtmContent = urlParams.get('utm_content');
        
        // Remove any existing fwSurvey values first
        const fwSurveyRegex = /_?fwSurvey-[^_]+/g;
        const cleanedUtmContent = currentUtmContent ? currentUtmContent.replace(fwSurveyRegex, '').replace(/^_+|_+$/g, '') : '';
        
        // Add the new fwSurvey value
        const newUtmContent = cleanedUtmContent 
            ? `${cleanedUtmContent}_fwSurvey-${skipType}`
            : `fwSurvey-${skipType}`;
        
        urlParams.set('utm_content', newUtmContent);
        
        // Update URL without reloading page
        const newUrl = `${urlString.split('?')[0]}?${urlParams.toString()}`;
        window.history.pushState({}, '', newUrl);
        
        // Update all elements with data-param attribute
        const newUrlParams = newUrl.includes('?') ? newUrl.split('?')[1] : '';
        document.querySelectorAll('[data-param]').forEach(element => {
            element.setAttribute('data-param', newUrlParams);
            if (element.href) {
                const baseHref = element.href.split('?')[0];
                element.setAttribute('href', baseHref + (newUrlParams ? '?' + newUrlParams : ''));
            }
        });
        
        // console.log(`Added fwSurvey-${skipType} to utm_content:`, newUtmContent);
    }
    
    $('#nextStep').on('click', function() {
        // Always update progress bar when Next Step is clicked (for multi-answer questions)
        updateProgressBar(currentSection + 1);
        
        // Move to next section (if not the last one)
        goToNextSection();

        // Scroll to top when navigating
        scrollToTop();
        
        $('#nextStep').addClass('hidden');

        // Get #header and #footer height when clicking next step
        getHeights();
    });

    // Initialize pagination navigation
    if ($('#pagination').length) {
        initPaginationNavigation();
    }

    pagination();

    // Initialize with first section
    updateSurveyClass(1);  

    // Get #header and #footer height
    getHeights();
    
    // Update #header and #footer height based on resize event
    $(window).on('resize', function() {
        getHeights();
    });

    //- Set current Year to footer Copyright
    if ($('#year').length) {
        let thisDate = new Date();
        $('#year').html(thisDate.getFullYear());
    }

    // Expose navigation functions globally for external use
    window.surveyNavigation = {
        goToNextSection: goToNextSection,
        goToPreviousSection: goToPreviousSection,
        goToSection: updateSurveyClass,
        getCurrentSection: () => currentSection,
        getTotalSections: () => totalQuestionSections,
        getSectionNames: () => sectionNames,
        getSectionName: (sectionNumber) => sectionNames[sectionNumber - 1]
    };
});

// Helper function to convert string to camelCase
function toCamelCase(str) {
    if (!str) return str;
    
    return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase())
        .replace(/^[A-Z]/, (match) => match.toLowerCase());
}
